export const GET_TIMEZONE_REQUEST = "GET_TIMEZONE_REQUEST";
export const GET_TIMEZONE_SUCCESS = "GET_TIMEZONE_SUCCESS";
export const GET_TIMEZONE_FAILED = "GET_TIMEZONE_FAILED";